<template>
<div class="base-lockup">
  <img src="@/assets/img/lockup-1.svg">
</div>
</template>

<script>
export default {
}
</script>

<style lang="scss" scoped>
.base-lockup {
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  width: 100%;
  @media #{$media-3} {
    width: 25rem;
  }
}
img {
  width: 100%;
  display: block;
}
</style>
